
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#messager_svg__clip0_5377:53228)"}},[_c('path',{attrs:{"d":"M12 0C5.241 0 0 4.953 0 11.64c0 3.498 1.434 6.522 3.768 8.61.195.174.315.42.321.684l.066 2.136a.96.96 0 001.347.849l2.382-1.05a.964.964 0 01.642-.048c1.095.3 2.259.462 3.474.462 6.759 0 12-4.953 12-11.64S18.759 0 12 0z","fill":"url(#messager_svg__paint0_radial_5377:53228)"}}),_c('path',{attrs:{"d":"M4.794 15.045l3.525-5.592a1.8 1.8 0 012.604-.48l2.805 2.103a.72.72 0 00.867-.003l3.786-2.874c.504-.384 1.164.222.828.759l-3.528 5.589a1.8 1.8 0 01-2.604.48l-2.805-2.103a.72.72 0 00-.867.003l-3.786 2.874c-.504.384-1.164-.219-.825-.756z","fill":"#fff"}})]),_c('defs',[_c('radialGradient',{attrs:{"id":"messager_svg__paint0_radial_5377:53228","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"translate(4.62 23.87) scale(26.1504)"}},[_c('stop',{attrs:{"stop-color":"#09F"}}),_c('stop',{attrs:{"offset":".61","stop-color":"#A033FF"}}),_c('stop',{attrs:{"offset":".935","stop-color":"#FF5280"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FF7061"}})]),_c('clipPath',{attrs:{"id":"messager_svg__clip0_5377:53228"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    